export default __webpack_public_path__ + "567945fcc1cb6dfed680ee7f9bc0a489.jpg";